<template>
  <div class="wrapper">
    <div class="bg-card">
      <div class="d-flex justify-content-between">
        <strong>{{ $t('pages.user-cv.employment.title', 'Employment situation') }}</strong>
        <b-button
          v-if="$route.name == 'my-cv'"
          class="cv-button"
          @click="$emit('levelsModalOpen')"
        >
          {{ $t('pages.user-cv.employment.edit-button', 'Edit employment situation') }}
        </b-button>
      </div>
      <hr style="width: 100%; background: unset;">
      <div style="font-size: 0.9rem">
        <div class="d-flex justify-content-between flex-wrap">
          <!-- Levels and experience -->
          <div
            v-if="levels"
            class="mb-2 mb-sm-0"
          >
            {{ $t('pages.user-cv.employment.preferred-levels', 'Level preferences') }}:
            <ul class="d-flex flex-wrap">
              <li
                v-for="level in JSON.parse(levels)"
                :key="level"
              >
                {{ $t(`data.levels.${level}`, level) }}
              </li>
            </ul>
          </div>
          <div v-if="experienceTime">
            <div>{{ $t('pages.user-cv.employment.my-experience', 'My experience') }}:</div>
            <ul>
              <li>{{ $t(`data.experience.${experienceTime}`, experienceTime) }}</li>
            </ul>
          </div>
        </div>
        <hr>
        <!-- Categories and Industries  -->
        <div class="d-flex justify-content-between flex-wrap">
          <div
            v-if="categories"
            class="mb-2 mb-md-0"
          >
            {{ $t('pages.user-cv.employment.preferred-categories', 'Category preferences') }}:
            <ul class="d-flex flex-wrap">
              <li
                v-for="category in JSON.parse(categories)"
                :key="category"
              >
                {{ $t(`data.categories.${category}`, category) }}
              </li>
            </ul>
          </div>
          <div v-if="industries">
            {{ $t('pages.user-cv.employment.preferred-industries', 'Industry preferences') }}:
            <ul class="d-flex flex-wrap">
              <li
                v-for="industry in JSON.parse(industries)"
                :key="industry"
              >
                {{ $t(`data.industryTypes.${industry}`, industry) }}
              </li>
            </ul>
          </div>
        </div>
        <hr>
        <!-- Contracts -->
        <div class="d-flex justify-content-between">
          <div v-if="contracts">
            {{ $t('pages.user-cv.employment.preferred-contracts', 'Contract preferences') }}:
            <ul class="d-flex flex-wrap">
              <li
                v-for="contract in JSON.parse(contracts)"
                :key="contract"
              >
                {{ $t(`data.contractTypes.${contract}`, contract) }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    levels: {
      type: String,
      default: ""
    },
    experienceTime: {
      type: String,
      default: ""
    },
    categories: {
      type: String,
      default: ""
    },
    industries: {
      type: String,
      default: ""
    },
    contracts: {
      type: String,
      default: ""
    },
  }
}
</script>


<style scoped lang="scss">
  ul {
    margin-bottom: 0;
  }

  ul li {
    padding: 0 15px;
    list-style: none;
  }

  ul li::before {
    content: "\2022";
    color: #009090;
    font-weight: bold;
    display: inline-block;
    width: 0.8em;
    margin-left: -1em;
  }
</style>
